const CurrentDate = () => {
    const day = new Date().getDate()
    let formattedDay = (day < 10 ? `0${day}`: `${day}`)
    const month = new Date().getMonth() + 1
    let formattedMonth = (month < 10 ? `0${month}`: month)
    const year = new Date().getFullYear()

    return `${year}-${formattedMonth}-${formattedDay}`
}

export default CurrentDate